<article>
    <h1 i18n>What is this tool for?</h1>

    <p i18n>
        Welcome to the <strong>GenAI reflection tool</strong>. This tool is
        designed to reflect on the impact of GenAI on the learning goals of
        individual courses. It works best if you run this tool with a particular
        course in mind (and to have the course manual ready). The tool will
        guide you through some steps (see below) that challenge you to reflect
        on the validity of the intended learning outcomes of the course and the
        effectiveness of the assignments to test these. Once finished, you will
        be offered a report with an overview of the outcomes.
    </p>

    <p i18n>
        You can run the tool as many times and for as many courses as you like.
        We do not store or save the information you enter in this tool.
    </p>

    <section class="my-4">
        <header>
            <h2 i18n>How the tool works</h2>
        </header>
        <p i18n>This tool consists of four subsequent steps:</p>
        <ul>
            <li i18n>
                <strong class="step-title">
                    🌍 Step 1: Learning outcomes analysis
                </strong>
                clarify and map your course goals.
            </li>
            <li i18n>
                <strong class="step-title"> 🚀 Step 2: Assessments </strong>
                assess whether the use of generative AI in assignments
                negatively impacts the learning outcomes.
            </li>
            <li i18n>
                <strong class="step-title">
                    🌙 Step 3: Rethinking courses in times of GenAI
                </strong>
                explore how generative AI can be used to enhance your course.
            </li>
            <li i18n>
                <strong class="step-title"> ✨ Step 4: Report </strong>
                after finishing the tool you can download a report with the most
                important outcomes.
            </li>
        </ul>
    </section>

    <section class="my-4">
        <header>
            <h2 i18n>Before we begin...</h2>
        </header>
        <p i18n>
            Please provide the name of your course. This will personalize the
            final report.
        </p>
        <form [formGroup]="form" (ngSubmit)="submitCourseName($event)">
            <label for="course" class="form-label" i18n>Course name</label>
            <input
                id="course"
                type="text"
                class="form-control"
                [class.is-invalid]="
                    form.controls.course.invalid && form.controls.course.touched
                "
                [formControl]="form.controls.course"
                placeholder="Enter the name of your course..."
                i18n-placeholder
            />
        </form>
        @if (form.controls.course.invalid && (form.controls.course.touched ||
        form.controls.course.dirty)) {
        <p class="invalid-feedback always-block my-1" i18n>
            Please enter a course name in the field above.
        </p>
        }
    </section>
</article>

<gr-nav-buttons [navButtons]="navButtons" />
